
import React from 'react';
import ClassAssembly8B  from 'views/ClassAssembly8C';

const ClassAssembly5EPage = () => {
    return <ClassAssembly8B />;
  };
  
  export default ClassAssembly5EPage;